import { SVGProps } from "react";


const PlayIcon = ({
	width = 16,
	height = 15,
	fill = "#00AEC7",
	...otherProps
}: SVGProps<SVGSVGElement>) => (

	<svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...otherProps}>
		<path d="M28.3305 19.6621L4.58839 34.0909C2.92192 35.1347 0.742188 33.9604 0.742188 31.9383V3.08057C0.742188 1.05853 2.92146 -0.180968 4.58839 0.927957L28.3305 15.3568C29.8687 16.3356 29.8687 18.6834 28.3305 19.6621Z" fill="white"/>
	</svg>

);

export default PlayIcon;
